import React from 'react';
import './LoadingSpinner.css';

export const LoadingSpinner = ({ size = 'medium', message, fullScreen = false }) => {
  const spinner = (
    <div className={`spinner-wrapper ${fullScreen ? 'spinner-fullscreen' : ''}`} role="status" aria-live="polite">
      <div className={`spinner spinner-${size}`}>
        <div className="spinner-circle"></div>
      </div>
      {message && <p className="spinner-message">{message}</p>}
      <span className="sr-only">Loading...</span>
    </div>
  );

  return spinner;
};

